<template>
  <loader v-if="loading"></loader>
  <div v-else class="animated fadeIn pt-4">
    <section-header title="Sessioni utente">
    </section-header>
    <b-card>
      <data-table :value="results" :columns="columns"></data-table>
    </b-card>
    <div class="mb-4 text-right">
      <b-button variant="primary" @click.prevent="find()">Aggiorna</b-button>
    </div>
  </div>
</template>
<script>
import BasePageMixin from 'vue-core/mixins/BasePageMixin';
import SystemService from 'app/services/SystemService';

export default {
  mixins: [ BasePageMixin ],

  created() {
    this.columns = [
      {
        label: 'Utente',
        type: 'component',
        component: 'user-input-field',
        class: 'col-3',
        props: (item, index) => ({
          disabled: true,
          plaintext: true,
          inputId: true,
          value: item.userId,
        })
      },
      { label: 'Inizio' , type: 'timestamp', value: (item) => item.created },
      { label: 'Fine'   , type: 'timestamp', value: (item) => item.destroyed },
      { label: 'IP'     , value: (item) => item.clientIp },
      { label: 'Browser', value: (item) => item.userAgent, class: 'col-4 text-truncate' },
    ];
  },

  mounted() {
    this.find();
  },

  data() {
    return {
      results: []
    };
  },

  computed: {
    breadcrumbs() {
      return [
        {
          label: 'Home',
          link: '/protected'
        },
        {
          label: 'Sessioni utente',
        }
      ];
    },
  },

  methods: {
    find() {
      const success = ({ statusCode, data }) => {
        console.log('SESSIONI', data);
        this.results = data;
        this.loading = false;
      };

      const error = this.handleError.bind(this);

      this.loading = true;
      SystemService.sessions()
          .then(success, error);
    },
  }
};
</script>
